export default "__VITE_ASSET__BxBuLO7w__ 100w";